<template>
  <div id="app">
    <Header v-if="!isMobile" />
    <HeaderMobile v-if="isMobile" />
    <router-view />
    <FooterForm v-if="$route.path != '/free'&&$route.path != '/training'" />
    <FooterFormTraining v-if="$route.path == '/training'" />
    <Footer />
  </div>
</template>

<script>
import Header from "./components/Header.vue";
import HeaderMobile from "./components/HeaderMobile.vue";
import Footer from "./components/Footer.vue";
import FooterForm from "./components/footer-form.vue";
import FooterFormTraining from "./components/footer-form-training.vue";


export default {
  name: "App",
  components: {
    Header,
    Footer,
    FooterForm,
    HeaderMobile,
    FooterFormTraining,
  },
  data() {
    return {
      isMobile: false,
    };
  },
  mounted() {
    // 判断是否为移动设备
    const isMobile = window.innerWidth < 1300;
    this.isMobile = isMobile;
  },
  watch: {
    $route: {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
        if (newValue?.fullPath != oldValue?.fullPath) {
          window.scrollTo(0, 0);
        }
      },
    },
  },
};
</script>

<style>
#app {
  font-family: "PingFang SC", Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #1f2329;
  background: #f6f8fd;
}


.mt-16 {
  margin-top: 16px;
}

.mt-24 {
  margin-top: 24px;
}

.mb-40 {
  margin-bottom: 40px;
}

.medical-detail-cntainer {
  background: #f6f8fd;
}

.card {
  width: 100%;
  height: 100%;
  background-color: #fff;
  border-radius: 8px;
  border: 1px solid #e9dbdf;
  padding: 32px;
}

.card-title {
  color: #1f2329;
  font-size: 20px;
  font-weight: 500;
  margin-bottom: 8px;
}


.card-desc {
  color: #50627f;
  font-size: 16px;
}

.under-line-title {
  font-size: 22px;
  font-weight: 500;
}

.under-line-title::after {
  content: '';
  display: block;
  width: 100%;
  height: 2px;
  margin-top: 8px;
  background-image: linear-gradient(90deg, #386FC6 0%, rgba(28, 179, 184, 0.586538) 41.83%, rgba(28, 179, 184, 0) 100%);
}

.under-line-title-title {
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 8px;
}

.under-line-title-desc {
  font-size: 16px;
  color: #50627f;
}

.under-line-section {
  margin-top: 64px;
  background: linear-gradient(270deg, rgba(28, 179, 184, 0) 0%, rgba(28, 179, 184, 0.08) 100%);
  padding: 12px 24px;
  width: 100%;
  position: relative;

}

.under-line-section::after {
  content: '';
  display: block;
  width: 100%;
  height: 2px;
  position: absolute;
  bottom: 0;
  left: 0;
  background-image: linear-gradient(90deg, #386FC6 0%, rgba(28, 179, 184, 0.586538) 41.83%, rgba(28, 179, 184, 0) 100%);
}

.under-line-section::before {
  content: '';
  display: block;
  width: 100%;
  height: 2px;
  position: absolute;
  top: 0;
  left: 0;
  background-image: linear-gradient(90deg, #386FC6 0%, rgba(28, 179, 184, 0.586538) 41.83%, rgba(28, 179, 184, 0) 100%);
}




.under-line-section-title {
  font-size: 32px;
  font-weight: 500;
  color: #1CB3B8;
  margin-bottom: 8px;
}

.under-line-section-subTitle {
  font-size: 22px;
  font-weight: 500;
}

.example-title {
  font-size: 20px;
  font-weight: 500;
  color: #1F2329;
  padding: 11px 16px;
  background: linear-gradient(90deg, rgba(28, 179, 184, 0.1) 0%, rgba(56, 111, 198, 0.1) 100%);
  border: 1px solid rgba(28, 179, 184, 0.4);
  border-radius: 8px 8px 0 0;
}

.example-item-title {
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 8px;
  color: #1F2329;
}

.example-item-desc {
  font-size: 16px;
  color: #50627f;
}

.section {
  margin-bottom: 80px;
}

.section:last-child {
  margin-bottom: 0;
}

.section>.title {
  color: #1f2329;
  font-size: 40px;
  font-weight: 600;
  margin-bottom: 32px;
}

.section .disc {
  text-align: justify;
  color: #50627f;
  font-size: 16px;
  line-height: 170%;
  letter-spacing: -0.16px;
  margin-bottom: 32px;
}

a {
  text-decoration: none;
}

.main-content {
  width: 1328px;
  margin: 0 auto;
}

.page {
  margin-top: -200px;
}

.flex {
  display: flex;
  align-items: center;
  gap: 16px;
}

.flex-vertical {
  display: flex;
  flex-direction: column;
}

.flex-1 {
  flex: 1;
}

.flex-2 {
  flex: 2;
}

.flex-3 {
  flex: 3;
}

.h-100 {
  height: 100%;
}

.justify-between {
  justify-content: space-between;
}


.rows-2 {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

.rows-3 {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
}

.rows-4 {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
}

.rows-5 {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 16px;
}

.border {
  border: 1px solid #e9dbdf;
}

.border-top-dash {
  border-top: 1px dashed #e9dbdf;
}

.p-16 {
  padding: 16px;
}

.p-32 {
  padding: 32px;
}

.px-16 {
  padding-left: 16px;
  padding-right: 16px;
}

.py-24 {
  padding-top: 24px;
  padding-bottom: 24px;
}

.pt-16 {
  padding-top: 16px;
}

.pt-32 {
  padding-top: 32px;
}

.radius-8 {
  border-radius: 8px;
}

.bg-green {
  background-color: #F4FAFA;
}


.font-26 {
  font-size: 26px;
}

.font-weight-500 {
  font-weight: 500;
}



@media screen and (max-width: 1300px) {

  .m-p-8 {
    padding: 8px !important;
  }

  .m-m-b-8 {
    margin-bottom: 8px !important;
  }

  .m-font-16 {
    font-size: 16px !important;
  }

  .card {
    padding: 16px;
  }

  .card-title {
    font-size: 16px !important;
  }


  .card-desc {
    font-size: 14px !important;
  }

  .m-rows-2 {
    display: grid;
    gap: 16px;
    grid-template-columns: repeat(2, 1fr) !important;
  }

  .m-rows-1 {
    display: grid;
    gap: 16px;
    grid-template-columns: repeat(1, 1fr) !important;
  }

  .p-32 {
    padding: 16px !important;
  }

  .pt-32 {
    padding-top: 16px !important;
  }

}
</style>
